import { c as _c } from "react/compiler-runtime";
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '@cc-shopping/structured-content-renderer/hydration/types';
import { renderStructuredContent } from '@cc-shopping/structured-content-renderer/renderContext';
import { Box } from '@mui/material';
export const CreditCardsMultiCompareSectionItem = t0 => {
  const $ = _c(6);
  const {
    props
  } = t0;
  if (!props.children) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "grid",
      height: "100%"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      padding: "1rem"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== props.children) {
    t3 = renderStructuredContent(props.children);
    $[2] = props.children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <Box sx={t1}><Box sx={t2}>{t3}</Box></Box>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};